import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getDocuments } from "../../redux/actions/actionDocument";
import {
  getInDocuments,
  postInDocuments,
} from "../../redux/actions/actioninDocument";
import { getClientes } from "../../redux/actions/actionClient";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import ItemsDocument from "./itemsDocuments";
import Swal from "sweetalert2";
import { customStyles } from "../../Constantes/constantesEstilos";

export default function InDocumentCreate() {
  const auxDate = new Date();
    
  const initialForm = {
    numberDocument: "",
    quantityItems: [],
    dateReception: new Date(),
    itemsMissing: [],
    userId: "",
    document_id: "",
    client_id: "",
  };

  const itemsDocuments = {
    documentId: "",
    itemsDoc: "",
  };

  const dispatch = useDispatch();
  const [form, setForm] = useState(initialForm);
  const documents = useSelector((state) => state.documents.allDocuments);  
  const clients = useSelector((state) => state.clientes.allClientes);
  const inDocuments = useSelector((state) => state.inDocuments.allInDocuments);
  const [startDate] = useState(new Date());
  const [itemsDocument, setItemsDocument] = useState(itemsDocuments);  
  const [errors, setErrors] = useState({});
  
  
  useEffect(() => {
    dispatch(getDocuments());
    // dispatch(getItems());
    dispatch(getClientes());
    dispatch(getInDocuments());
  }, [dispatch]);
  
  const newDocuments = documents !== undefined ? structuredClone(documents[0]): null
  console.log(documents)
  const inDocumentsClone = inDocuments !== undefined ? structuredClone(inDocuments[0]) : null
  console.log(inDocumentsClone)

  

  console.log(newDocuments)
  console.log(inDocuments);
  
  
  const auxDocuments = newDocuments !== undefined ? newDocuments.filter((e) => e.client_id._id === form.client_id && e.state === false) : null //filtro documentos por clientes  (e) => e.client_id._id === form.client_id && e.state === false
  console.log(auxDocuments)
  
  const auxDocumentsFilter = newDocuments !== undefined ? newDocuments.filter(
    (e) => e._id === form.document_id) : null //filtra el documento seleccionado para mostrarlo en pantalla
    console.log(auxDocumentsFilter)
    
    
    const documentsInFilter = inDocuments.length > 0 ? inDocuments[0].filter(e => e.client_id[0]._id === form.client_id) : null; //filtro los inDocuments por cliente 
    console.log(documentsInFilter)
    
    const auxDocumentsInFilter = documentsInFilter !== null ? documentsInFilter.filter(e => e.document_id && e.document_id._id === form.document_id) : null
    console.log(auxDocumentsInFilter)
    const inDocumentLast = auxDocumentsInFilter && auxDocumentsInFilter[0] 
    console.log(inDocumentLast)
    
    const codeDocument = (inDocuments[1] + 1);

  const handleDateReception = (date) => {
    console.log("FECHA")
       
    setForm({
      ...form,
      dateReception: date
    });
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleClient = (e) => {
    setForm({
      ...form,
      client_id: e.value,
    });
  };

  const handleDocument = (e) => {
    

    setForm({
      ...form,
      document_id: e.value,
      quantityItems: [],
      itemsMissing: [],
    });

    if (e.value) {
      console.log(e.value);
      const aux = newDocuments.filter((x) => x._id === e.value);     
      console.log(aux); 
      const aux1 = aux.map((x) => x.quantityItems);
      console.log(aux1[0]);
      
      aux1[0].forEach((x) => (x.quantity = ""));
      aux1[0].forEach((x) => (x.condition = false));

      console.log(form.client_id);      
      const documentsInFilter =  inDocumentsClone.filter(x => x.client_id[0]._id === form.client_id) //filtro los inDocuments por cliente 
      console.log(documentsInFilter)
  
      const auxDocumentsInFilter = documentsInFilter.filter(x => x.document_id._id === e.value)
      console.log(auxDocumentsInFilter)
      const inDocumentLastClone = auxDocumentsInFilter[0] 
      console.log(inDocumentLastClone)
      
      inDocumentLastClone.itemsMissing.forEach((x) => (x.quantity = ""));
      //inDocumentLastClone.forEach((x) => (x.condition = false));

      setItemsDocument({
        ...itemsDocument,
        documentId: e.value,
        itemsDoc: inDocumentLastClone ? inDocumentLastClone.itemsMissing : aux1[0].map((x) => x)
      });     
    }
  };

  const handleQuantity = (x) => {
    const { value } = x.target;
    console.log("esto es el valor de VALOR")
    
  };

  const handleEnterItem = (x, quantity, item) => {
    const { value } = x.target;
  //   console.log("esto es valor " + value)
  //   console.log("esto es cantidad " + quantity)
  // Number(quantity) ? console.log("es un numero") : console.log("no es un numero")

  if(x.key === "Enter"){

    if (parseInt(value) === parseInt(quantity)) {
      console.log("Valor y cantidad iguales")
      const aux = form.quantityItems.find((x) => item === x.item);
      console.log(aux)
      if(aux){
      aux.quantity = parseInt(value);
      const deleteItemMissing = form.itemsMissing.filter(e => e.item !== item)
      setForm({
        ...form,        
        itemsMissing: deleteItemMissing,
      });
      } else {        
        const aux = itemsDocument.itemsDoc.find((x) => item === x.item); // se filtra el objeto al cual se le cambia la cantidad
            aux.quantity = value; //se le asigna el valor a la cantidad

            const auxItemQuantity = structuredClone(itemsDocument.itemsDoc); //se guarda en una variable un clon del estado itemsDocument, para evitar referencia y poder hacer diferentes cambios
            const auxItem = auxItemQuantity.find((x) => x.item === item);
            auxItem.quantity = value; //se le asigna el valor a l

            setForm({
              ...form,
              quantityItems: [...form.quantityItems, auxItem]
            })
      }
    }

    if (parseInt(value) < quantity && parseInt(value) > 0) {
      //console.log("valor menor a cantidad")

      Swal.fire("La cantidad es menor a la esperada")
          const itemInclude = form.quantityItems.find((x) => x.item === item);
          const itemsMissingInclude = form.itemsMissing.find((x) => x.item === item);
          console.log(itemInclude && itemsMissingInclude)

          if (itemInclude && itemsMissingInclude) {
            //console.log("Entro en el primero");
            itemInclude.quantity = value;
            itemsMissingInclude.quantity = quantity - value;
            // setForm({
            //   ...form,
            // });
          } else if(itemInclude && !itemsMissingInclude){
            //console.log("Entro en el segundo");
            itemInclude.quantity = value;

            const aux = itemsDocument.itemsDoc.find((x) => item === x.item); // se filtra el objeto al cual se le cambia la cantidad
            aux.quantity = value; //se le asigna el valor a la cantidad

            const auxMissing = structuredClone(itemsDocument.itemsDoc); //se guarda en una variable un clon del estado itemsDocument, para evitar referencia y poder hacer diferentes cambios
            const auxItem = auxMissing.find((x) => x.item === item);
            auxItem.quantity = quantity - value; //se le asigna el valor a l

            setForm({
              ...form,
              itemsMissing: [...form.itemsMissing, auxItem]
            })
          } 
          else {
            console.log("es un numero menor")
            /////////////////
            const aux = itemsDocument.itemsDoc.find((x) => item === x.item); // se filtra el objeto al cual se le cambia la cantidad
            aux.quantity = value; //se le asigna el valor a la cantidad

            const auxMissing = structuredClone(itemsDocument.itemsDoc); //se guarda en una variable un clon del estado itemsDocument, para evitar referencia y poder hacer diferentes cambios
            const auxItem = auxMissing.find((x) => x.item === item);
            auxItem.quantity = quantity - value; //se le asigna el valor a la cantidad haciendo quantity - value

            setItemsDocument({ //se actualiza la cantidad con el valor del evento                                
              ...itemsDocument              
            });
            setForm({
              ...form,
              quantityItems: [...form.quantityItems, aux], //se actualizan el estado principal
              itemsMissing: [...form.itemsMissing, auxItem],
            });
          }
    }

    if (value === "0"){
      Swal.fire({
        title: "La cantidad es 0 ¿Esta seguro?",
        showCancelButton: true,
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          const itemInclude = form.itemsMissing.find((x) => x.item === item);

          if (itemInclude) {
            const auxQuantityItems = form.quantityItems.find(
              (x) => x.item === item
            );
            auxQuantityItems.quantity = value;

            const auxItemMissing = form.itemsMissing.find(
              (x) => x.item === item
            );
            auxItemMissing.quantity = quantity - value;

            setForm({
              ...form,
            });
          } else {
            const aux = itemsDocument.itemsDoc.find((x) => item === x.item); // se filtra el objeto al cual se le cambia la cantidad
            aux.quantity = value; //se le asigna el valor a la cantidad

            const auxMissing = structuredClone(itemsDocument.itemsDoc); //se guarda en una variable un clon del estado itemsDocument, para evitar referencia y poder hacer diferentes cambios
            const auxItem = auxMissing.find((x) => x.item === item);
            auxItem.quantity = quantity - value; //se le asigna el valor a la cantidad haciendo quantity - value

            setItemsDocument({ //se actualiza la cantidad con el valor del evento                                
              ...itemsDocument              
            });
            setForm({
              ...form,
              quantityItems: [...form.quantityItems, aux], //se actualizan el estado principal
              itemsMissing: [...form.itemsMissing, auxItem],
            });
          }
        }
      })
    }

    if (value > quantity) {
      Swal.fire("La cantidad no puede ser mayor a la esperada");
      setErrors({
        item
      })      
    } else {
      setErrors({})
    }

    if(value === ""){
        Swal.fire('Debe ingresar una cantidad igual a 0 o mayor')
        setErrors({
          item
        })
    }else {
      setErrors({})
    }
  }
  };
  
  console.log(errors);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(itemsDocument)
    let auxItem = await itemsDocument.itemsDoc.filter(e=> e.quantity === "")
    console.log(auxItem);
    if(auxItem.length > 0){
      Swal.fire("Figuran articulos sin cantidad a saldar, esta debe ser de 0 o superior")
      return
    }

    dispatch(postInDocuments(form));
    setForm({
      //numberDocument: "",
      quantityItems: [],
      dateReception: "",
      itemsMissing: [],
      userId: "",
      document_id: "",
      client_id: "",
    });
    setTimeout(() => {
      window.location.reload();      
    }, "500");
  };

  return (
    <div className="container bg-gray-900">
      <div className="m-8 text-orange-500 font-bold">
      <div>
                <p className="text-xl pb-4">Remitos - Entrada</p>
            </div>
        <div className="flex justify-between text-[10pt] pb-4 border-b-2">
        <div>
          Fecha: {format(new Date(auxDate), "dd/MM/yyyy")}
        </div>
        <div>
          <label>N° Documento </label>
          <input
            className="w-28 bg-slate-700 pl-3"
            type="text"
            name="numberDocument"
            onChange={handleChange}
            value={codeDocument}
            required={true}
          />
        </div>
        </div>
        <div className="flex border-b-2 py-4 text-[10pt]">
          <label className="w-60 text-[10pt]">Fecha de Recepción</label>
          <DatePicker
          className="w-24 pl-3 ml-2 rounded bg-slate-700"
            selected={startDate}
            onChange={handleDateReception}
            //onBlur={handleBlurDate}
            value={form.dateReception ? format(form.dateReception, "dd/MM/yyyy") : null}
          />
        </div>
        <div className="flex py-4 text-[10pt] justify-between">
        <div className="flex w-1/3">
        <label className="w-36">Seleccionar Cliente</label>
        <div className="w-52">
          <Select
            styles={customStyles}
            placeholder="Clientes"
            options={clients.map((e) => ({ label: e.nameCompany, value: e._id }))}
            onChange={handleClient}
          />
          </div>
        </div>
        <div className="flex w-1/3 mr-2">
        <label className="w-40">Seleccionar Documento</label>
        <div className="w-40">
          <Select
            styles={customStyles}
            placeholder="Documentos"
            options={auxDocuments && auxDocuments.map((e) => ({
              label: ["N° Documento", " ", e.numberDocument, " - ", e.dateSend],
              value: e._id,
            }))}
            onChange={handleDocument}
          />
          </div>
        </div>
        </div>
        <div>
          {form.document_id === "" ? (
            <div>
            <div className="flex text-[10pt] border-y-2 py-4">
              <div className="w-1/3">Documento N°: </div>
              <div className="w-1/3">Fecha de Salida: </div>
              <div className="w-1/3">Fecha de Reingreso: </div>
            </div>
              <div className="font-bold text-[10pt]">Articulos: </div>
            </div>
          ) : (
          <div>
            {inDocumentLast !== undefined ? (
              <div>
              {auxDocumentsFilter.map((e) => {
                return (
                  <div key={e._id}>
                    <div className="flex text-[10pt] border-y-2 py-4">
                      <div className="w-1/3">Documento N°: {e.numberDocument}</div>
                      <div className="w-1/3">Fecha de Salida: {format(new Date(e.dateSend), "dd/MM/yyyy")}</div>
                      <div className="w-1/3">Fecha de Reingreso: {format(new Date(e.dateReception), "dd/MM/yyyy")}</div>
                    </div>
                    <div>
                      <h2 className="py-4 font-bold text-[12pt]">Articulos:</h2>
                      <div className="flex text-[10pt] border-b-2 border-slate-500">
                        <div className="w-1/3">Nombre de articulo</div>
                        <div className="w-2/5">Descripcion</div>
                        <div className="w-20 text-center">Cantidad</div>
                        <div className="w-20 text-center">Cantidad a Ingresar</div>
                      </div>
                      
                    </div>
                  </div>
                );
              })}
              <div>
              {inDocumentLast.itemsMissing.map(e => (
                <ItemsDocument 
                  key={e.item}
                  item={e.item}                             
                  name={e.name}
                  descrip={e.descrip}
                  quantity={e.quantity}                   
                  handleEnterItem={handleEnterItem}
                  handleQuantity={handleQuantity}
                  //handleQuantity={(x) => handleQuantity(x, e.quantity, e.item)}
                />
              ))}
              </div>
              </div>
            ) : (              
            <div>
              {auxDocumentsFilter.map((e) => {
                return (
                  <div key={e._id}>
                    <div className="flex text-[10pt] border-y-2 py-4">
                      <div className="w-1/3">Documento N°: {e.numberDocument}</div>
                      <div className="w-1/3">Fecha de Salida: {format(new Date(e.dateSend), "dd/MM/yyyy")}</div>
                      <div className="w-1/3">Fecha de Reingreso: {format(new Date(e.dateReception), "dd/MM/yyyy")}</div>
                    </div>
                    <div>
                      <h2 className="py-4 font-bold text-[12pt]">Articulos:</h2>
                      <div className="flex text-[10pt] border-b-2 border-slate-500">
                        <div className="w-1/3">Nombre de articulo</div>
                        <div className="w-2/5">Descripcion</div>
                        <div className="w-20 text-center">Cantidad</div>
                        <div className="w-20 pl-2">Cantidad a Ingresar</div>
                      </div>
                      {e.quantityItems.map(e => (
                        <ItemsDocument
                            key={e.item}
                            item={e.item}                             
                            name={e.name}
                            descrip={e.descrip}
                            quantity={e.quantity}                             
                            handleEnterItem={handleEnterItem}
                            handleQuantity={handleQuantity}
                            //handleQuantity={(x) => handleQuantity(x, e.quantity, e.item)}                                           
                        /> 
                      ))}                      
                    </div>
                  </div>
                );
              })}
            </div>
            )}
            </div>

          )}
        </div>
        <div>
          {form.itemsMissing.length === 0 ? (
            <div>No hay faltantes de artículos</div>
          ) : (
            <div className="py-4 mt-3">
              <div className="text-[12pt] font-bold">Articulos Faltantes</div>
              {form.itemsMissing.map((e, index) => {
                return (
                  <div key={e.item} className="flex text-[9pt] pt-2 text-red-600 border-b-2 border-slate-500">
                    <div className="w-1/3">{e.name}</div>
                    <div className="w-2/5">{e.descrip}</div>
                    <div className="w-20 text-center">{e.quantity}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div>
          <button className="mt-12 p-4 rounded bg-sky-500 text-white" onClick={handleSubmit}>Guardar</button>
        </div>
      </div>
    </div>
  );
}
